import React, { useState } from 'react'
import classNames from 'classnames'
import { PulseLoader } from "react-spinners";

import "../../../assets/sass/components/forms/report-generate-type.scss"

import { ReactComponent as IlsFilePDF } from '../../../assets/svg/ils/ils-file-pdf.svg';
import { ReactComponent as IlsFileDOC } from '../../../assets/svg/ils/ils-file-doc.svg';
import { ReactComponent as IlsFileJPG } from '../../../assets/svg/icons/ils-file-jpg.svg';
import { ReactComponent as IlsFileCSV } from '../../../assets/svg/ils/ils-file-csv.svg';
import { ReactComponent as IlsFileXLS } from '../../../assets/svg/ils/ils-file-xls.svg';
import { Row, Col } from 'react-bootstrap';
import Spinner from '../feedback/Spinner';

// TODO: make documantation

const ChooseGenerateType = ({
    size = 'sm',
    showLabel = false,
    onChange = console.log,
    types = ['pdf', 'jpg', 'doc', 'csv', 'xls'],
    defaultType = '',
    typesProps = {
        pdf: {
            label: 'Download As PDF'
        },
        jpg: {
            label: 'Download As JPG'
        },
        doc: {
            label: 'Download As DOC'
        },
        csv: {
            label: 'Download As CSV'
        },
        xls: {
            label: 'Download As Excel'
        },
    },
    renderLoader: Loader = PulseLoader,
    isLoading = false,
    enableActive = true
}) => {
    const [activeType, setActiveType] = useState(defaultType);

    const handleChange = type => {
        setActiveType(type);
        onChange(type);
    }

    const isActive = type => activeType === type;

    return (
        <div className={classNames("report-generate-type", size)}>
            <Row className="gutters-8">
                {
                    types.map(type => {
                        return (
                            <Col sm={12 / types.length}>
                                <span
                                    key={type}
                                    className={classNames("type", type, { active: isActive(type) && enableActive, 'with-label': showLabel })}
                                    onClick={() => handleChange(type)}
                                >
                                    <Icon type={type} />
                                    {isActive(type) && isLoading ? (
                                        <Spinner variant="primary" />
                                    ) : showLabel && (
                                        <p className="label">{typesProps[type]['label']}</p>
                                    )}
                                </span>
                            </Col>
                        )
                    })
                }
            </Row>
        </div>
    )
}

const Icon = ({ type }) => {
    switch (type) {
        case 'pdf':
            return <IlsFilePDF />;
        case 'doc':
            return <IlsFileDOC />;
        case 'jpg':
            return <IlsFileJPG />;
        case 'csv':
            return <IlsFileCSV />;
        case 'xls':
            return <IlsFileXLS />;
        default:
            return null;
    }
}

export default ChooseGenerateType
